export const TEST_ID = 'johnDeereCallbackPage';
